import { Grid } from "@mui/material";
import { CloseButton, Container, Content, Label, Title } from "./styles";

interface Props {
  open: boolean;
  labels: string[];
  close: () => void;
}

const ErrorModal = ({ open, labels, close }: Props) => {
  return (
    <Container open={open}>
      <Content>
        <Title>Erro</Title>
        {labels.map((label, index) => (
          <Label key={index}>{label}</Label>
        ))}

        <Grid container justifyContent="center">
          <Grid item>
            <CloseButton onClick={close}>OK</CloseButton>
          </Grid>
        </Grid>
      </Content>
    </Container>
  );
};

export default ErrorModal;
